<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-2.18557e-07 5L1 6L4 3L4 10L5.4 10L5.4 3L8.4 6L9.4 5L4.7 0.3L-2.18557e-07 5Z"/>
</svg>
